<template>
  <div class="row align-items-center my-5">
    <div v-for="model in models" class="col-lg-3 col-12" :key="model.id">
      <NuxtLink
        :to="{name: 'language-modelos-name-making-of', params: {name: model.slug}}"
      >
        <div class="card-pagination pr-3">
          <div class="img-box">
            <img
              :src="`${model.cover}`"
              :alt="model.imageAltText ?? model.title"
              width="290"
              height="213"
            />
            <div class="play-icon">
              <font-awesome :icon="['fas', 'circle-play']" size="2xl" />
            </div>
          </div>
          <div class="card-body d-flex flex-column align-items-center">
            <h5 class="card-title my-3">{{ model.title }}</h5>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps(["models"]);
</script>
<style scoped lang="css">
.pagination-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
}

.paginate-buttons {
  height: 40px;
  width: 40px;
  border-radius: 20px;
  cursor: pointer;
  background-color: rgb(242, 242, 242);
  border: 1px solid rgb(217, 217, 217);
  color: black;
}

.paginate-buttons:hover {
  background-color: #d8d8d8;
}

.active-page {
  background-color: #b20000;
  border: 1px solid #b20000;
  color: white;
}

.active-page:hover {
  background-color: #b20000;
}

ul#componentContainer {
  display: flex !important;
  justify-content: center;
}

.card-title {
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}

.img-box {
  position: relative;
  width: 100%;
}

.img-box img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* Tamanho do ícone de reprodução */
  color: white;
  /* Cor do ícone de reprodução */
  cursor: pointer;
}

.card-pagination {
  background-color: transparent;
}
</style>
